import * as React from 'react'
import TagBadge from '../../../../shared/tags/badge'
import { ItemBoxType } from './item_types'

const { I18n } = window as any

type DirectProps = {
  number: string
  name: string
  regionName?: string
  action: () => void
  address?: {
    line1?: string
    line2?: string
    zip?: string
    city?: string
    country?: string
  }
  showRegions?: boolean
}

function Direct({ number, name, regionName, action, address, showRegions }: DirectProps) {
  address = address || {}

  let addressString = ''
  if (Object.keys(address).length > 0) {
    let addressParts = [address.line1, address.line2, address.zip, address.city, address.country]

    addressParts = addressParts.filter((part) => part !== null && part !== undefined)

    if (addressParts.length > 0) {
      addressString = addressParts.join(', ')
    }
  }
  return (
    <tr>
      <td>{number}</td>
      <td>{name}</td>
      {showRegions && <td>{regionName}</td>}
      <td>{addressString}</td>
      <td className="text-center">
        <a onClick={action} className="action-control">
          {I18n.t('application.actions.select')}
          &nbsp;
          <i className="fa fa-angle-double-right" />
        </a>
      </td>
    </tr>
  )
}

type ReverseProps = {
  id: number
  number: string
  name: string
  action: () => void
  tags?: Array<{ name: string; type: string; value: string }>
  approvedLocationIDs: Array<number>
  campaignLocationsNeedApproval?: boolean
}

function Reverse({ id, number, name, action, tags, approvedLocationIDs, campaignLocationsNeedApproval }: ReverseProps) {
  tags = tags || []

  return (
    <tr>
      <td className="text-center">
        <a onClick={action} className="action-control">
          <i className="fa fa-angle-double-left" />
          &nbsp;
          {I18n.t('application.actions.remove')}
        </a>
      </td>
      <td>{number}</td>
      <td>
        {name}
        {tags.map((tag) => (
          <TagBadge name={tag.name} type={tag.type} key={`tag-key-${tag.value}`} />
        ))}
      </td>
      {campaignLocationsNeedApproval && (
        <td>
          {approvedLocationIDs.includes(id) ? (
            <TagBadge
              name={I18n.t('activerecord.attributes.elements/base_element.approved.approved_yes')}
              type="Tags::Approved::Yes"
              key={`tag-key-yes-${id}`}
            />
          ) : (
            <TagBadge
              name={I18n.t('activerecord.attributes.elements/base_element.approved.approved_no')}
              type="Tags::Approved::No"
              key={`tag-key-no-${id}`}
            />
          )}
        </td>
      )}
    </tr>
  )
}

const DIRECTIONS = { direct: Direct, reverse: Reverse }

type RowItemProps = {
  item: ItemBoxType
  direction?: 'direct' | 'reverse'
  showRegions?: boolean
  approvedLocationIDs?: Array<number>
  campaignLocationsNeedApproval?: boolean
  action: (id: number) => void
}

export default function RowItem(props: RowItemProps) {
  const {
    item,
    direction = 'direct',
    showRegions,
    approvedLocationIDs = [],
    campaignLocationsNeedApproval,
    action,
  } = props
  const handleAction = () => {
    action(item.id)
  }

  const RowItemView = DIRECTIONS[direction] || Direct

  return (
    <RowItemView
      id={item.id}
      number={item.number}
      name={item.name}
      address={item.address}
      regionName={item.regionName}
      tags={item.matchedTags}
      action={handleAction}
      showRegions={showRegions}
      approvedLocationIDs={approvedLocationIDs}
      campaignLocationsNeedApproval={campaignLocationsNeedApproval}
    />
  )
}
